import { useState } from 'react'
import { IArpMedia } from '../../../../../features/arp-registry/ArpMedia'
import { useTreeState } from '../../../../stores/Root'

const DEFAULT_GAIN = 0.5

const useSampleListItem = (sampleData: IArpMedia) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)
  const { studio } = useTreeState()

  const playSample = async () => {
    if (isPlaying) {
      return studio.stopSample()
    }

    setIsLoading(true)

    studio.setSelectedSample(sampleData.id)
    await studio.playSample(sampleData.id, DEFAULT_GAIN, 0, setIsPlaying)

    setIsLoading(false)
    setIsPlaying(true)
  }

  return {
    isLoading,
    isPlaying,
    playSample
  }
}

export default useSampleListItem
